module.exports = __webpack_public_path__ + "static/media/twitter.aa0b011d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/twitter.svg
// module id = 1994
// module chunks = 0